import React from 'react';
import './techstack.css';

const techCategories = [
  {
    category: 'Frontend',
    technologies: ['React.js', 'JavaScript (ES6+)', 'CSS3', 'HTML5', 'Tailwind CSS', 'Redux','TypeScript','Angular'],
    icon: '🖥️',
    statement:'Along with these, we also work with additional modern frontend technologies to meet diverse project needs.'
  },
  {
    category: 'Backend',
    technologies: ['Node.js', 'Express.js', 'Java', 'Spring Boot', 'REST APIs', 'Python', '.Net', 'Redis', 'Kafka', 'RabbitMQ' ],
    icon: '⚙️',
    statement:'Our expertise further extends to additional backend frameworks and technologies for scalable solutions.'
  },
  {
    category: 'Database',
    technologies: ['MongoDB', 'MySQL', 'PostgreSQL', 'Firebase', 'Oracle DB', 'Microsoft SQL Server', 'Cassandra', 'Cosmos DB (Azure)' ,'DynamoDB (AWS)'],
    icon: '🗄️',
    statement:'We also utilize other advanced databases to ensure reliability and performance across applications.'
  },
  {
    category: 'DevOps & Tools',
    technologies: ['Git', 'Docker', 'Jenkins', 'AWS', 'Netlify', 'Vercel','Azure DevOps','Terraform','Kubernetes'],
    icon: '🛠️',
    statement:'Beyond these, our toolkit includes a wide range of DevOps tools to streamline deployment and operations.'
  },
  {
     category: 'Artificial Intelligence',
    technologies: ['Machine Learning','TensorFlow','PyTorch','Scikit-learn','OpenAI APIs','LangChain','Hugging Face Transformers','Computer Vision','Image Recognition','Document Intelligence'],
    icon: '🤖',
    statement:
      'We leverage cutting-edge AI frameworks and models to deliver intelligent, data-driven, and innovative solutions.'
  },
{
   category: 'Cloud',
    technologies: ['Amazon Web Services (AWS)','Microsoft Azure','Google Cloud Platform (GCP)','IBM Cloud','Heroku','Oracle Cloud Infrastructure (OCI)','Cloudflare'],
    icon: '☁️',
    statement:
      'Our cloud expertise spans across major platforms, ensuring scalable, secure, and efficient deployments.'
  }
  
];

export default function TechStack() {
  return (
    <div className="techstack-container">
      <h1 className="page-title">Our Tech Stack</h1>
      <p className="intro-text">
        At Neelaverse Technologies, we leverage a modern, scalable tech stack to build robust and
        innovative solutions tailored for startups and businesses alike.
      </p>
      <div className="cards-wrapper">
        {techCategories.map(({ category, technologies, icon,statement }) => (
          <div key={category} className="tech-card" tabIndex={0} role="region" aria-label={`${category} technologies`}>
            <div className="tech-icon">{icon}</div>
            <h2 className="tech-category">{category}</h2>
            <ul className="tech-list">
              {technologies.map((tech) => (
                <li key={tech} className="tech-item">{tech}</li>
              ))}
            </ul>
             <p className="tech-statement">{statement}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
